module.exports = __webpack_public_path__ + "img/lineup28@2x.f239ba5b.png";